export const RESPONSIVE_QUERIES = {
  mobile: "(max-width: 767px)",
  desktop: "(min-width: 768px)",
  desktopLayout: "(min-width: 1280px)",
  hover: "(hover: hover)",
  reducedMotion: "(prefers-reduced-motion: reduce)",
} as const;
